<template>
  <RouterView :account-id="$route.params.accountId" />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Teams',
        route: { name: 'manage-accounts-account-configurations-teams', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>

<style>

</style>
